import { Controller } from "@hotwired/stimulus"
import { morphTurboFrameElements } from "@hotwired/turbo"
import { get } from '@rails/request.js'

// Connects to data-controller="select"
export default class extends Controller {
  static targets = ["select"]
  static values=  {
    condition: { type: String },
    selector: { type: String },
    autoHide: { type: Boolean, default: true }
  }

  connect() {
    this.select = this.hasSelectTarget ? this.selectTarget : this.element
    if (this.autoHideValue && this.conditionValue && this.selectorValue) {
      this.showOrHide()
    }
  }

  // Je nach conditionValue wird das Element angezeigt oder versteckt
  showOrHide() {
    let targetElements = document.querySelectorAll(this.selectorValue)
    if (targetElements) {
      targetElements.forEach(element => {
        element.style.display = this.passesCondition ? "" : "none"
      })
    }
  }

  enableOrDisable() {
    document.querySelectorAll(this.selectorValue).forEach(element => {
      const tomSelect = this.application.getControllerForElementAndIdentifier(element, "tom-select")
      this.passesCondition ? tomSelect?.enable() : tomSelect?.disable()
    })
  }

  // Nach einer Änderung im Select ein Turbo Frame serverseitig updaten
  updateFrame({ params: { url, paramName, frame } }) {
    const requestURL = new URL(url, window.location.origin)
    requestURL.searchParams.append(paramName, this.select.selectedOptions[0].value)
    Turbo.visit(requestURL, { frame: frame })
  }


  // Identisch wie updateFrame, aber das Turbo Frame wird gemorpht statt ersetzt
  morphFrame({ params: { url, paramName, frame } }) {
    const requestURL = new URL(url, window.location.origin)
    requestURL.searchParams.append(paramName, this.select.selectedOptions[0].value)
    get(requestURL).then((response) => {
      response.html.then((html) => {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
        const currentFrame = document.getElementById(frame)
        const newFrame = parsedHTML.getElementById(frame)
        if (currentFrame && newFrame) {
          morphTurboFrameElements(currentFrame, newFrame)
        } else {
          console.error(`Frame with id ${frame} not found in current document or response.`)
        }
      })
    })
  }

  get passesCondition() {
    return this.select.value === this.conditionValue
  }
}
